import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import styled from "styled-components";

import { Dropdown, Menu, Spin, Table } from "antd";

import { handleError } from "../../modules/presence/sagas";
import { roles } from "../../configs/constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";

const MobileAppVersions = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchLastAppVersion = async () => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${baseapi}/mobile_app/last_version`, {
        headers: {
          Authorization: token
        }
      });
      if (result.data) setData([result.data]); // to use antd table we need to pass an array
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchLastAppVersion();
  }, []);
  const columns = [
    {
      title: "code",
      dataIndex: "code",
      key: "code",
      render: code => {
        return <span>{code}</span>;
      }
    },
    {
      title: "Date de sortie",
      dataIndex: "release_date",
      key: "release_date",
      render: date => {
        return <span> {`${dayjs(date).format("DD-MM-YYYY HH:mm:ss")}`}</span>;
      }
    },
    {
      title: "Notes",
      dataIndex: "release_note",
      key: "release_note"
    },

    {
      title: "lien",
      dataIndex: "link",
      key: "link"
    },
    {
      title: "num_code",
      dataIndex: "num_code",
      key: "num_code"
    }
  ];
  if (!Array.isArray(data)) return null;
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Lien vers la dernière version mobile disponible`}</div>
        </div>
        <div style={{ width: "30%" }} />
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
      </React.Fragment>
    </Container>
  );
};

export default MobileAppVersions;



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/LastMobileAppVersions.js